module.exports = __webpack_public_path__ + "img/shape_hearth--yellow.7cd17f7.webp";